/* eslint-disable react/jsx-tag-spacing */
import React       from 'react';
import PropTypes   from 'prop-types'
import { START }     from 'pu-data/QuoteSteps'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Collapse } from 'react-bootstrap'
import PriceVendor from './price_vendor/PriceVendor';

const VendorPrices = ({ quoteStep, quote, showSummary }) => {
  if (!quote || !quote.us_line_item_groups || !quote.us_line_item_combined) return null

  const usGroups = quote.us_line_item_groups
  const usCombined = quote.us_line_item_combined

  if (quoteStep === START) return null;

  if (!isManager || showSummary) return null;

  const [showTable, setShowTable] = React.useState(false)
  const showMessage = 'Show details '
  const hideMessage = 'Hide details '
  const [message, setMessage] = React.useState(showMessage)

  const onClick = () => {
    const temp = showTable ? showMessage : hideMessage
    setMessage(temp)
    setShowTable(!showTable)
  }

  const TableDetails = () => (
    usGroups.map((group, key) => (
      <PriceVendor
        key={key}
        quoteStep={quoteStep}
        usCombined={usCombined}
        group={group}/>
    ))
  )

  return (
    <div className="mb-4">
      <div className="vendor-groups">
        <div />
        <div>
          <a id="show-restrictions" onClick={onClick} aria-expanded={showTable}>
            {message}
            {showTable ? <FontAwesomeIcon icon="caret-up" /> : <FontAwesomeIcon icon="caret-down" />}
          </a>
          <Collapse in={showTable}>
            <div>
              <TableDetails />
            </div>
          </Collapse>
        </div>

      </div>
    </div>
  );
};

VendorPrices.propTypes = {
  quoteStep: PropTypes.string.isRequired,
  quote: PropTypes.object.isRequired,
  showSummary: PropTypes.bool.isRequired,
}

export default VendorPrices;
